const MODULE_NAME = "CALL_LOGGING";
const START_CALL_LOGGING = MODULE_NAME + 'START_CALL_LOGGING';
const SWITCH_INTERVIEW_GUIDE = MODULE_NAME + 'SWITCH_INTERVIEW_GUIDE';
const STOP_CALL_LOGGING = MODULE_NAME + 'STOP_CALL_LOGGING';
const LS_MINIMIZE_CALL_EVENT_KEY = 'call_logging_event';

export {
  START_CALL_LOGGING,
  STOP_CALL_LOGGING,
  LS_MINIMIZE_CALL_EVENT_KEY,
  SWITCH_INTERVIEW_GUIDE
};
